<template>
  <div class="reviews-item shop-reviews-item comment-reviews">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-3">
        <article class="tile is-child">
          <div class="d-flex align-items-center">
            <div class="avatar-resize">
              <router-link :to="{name: 'CustomerReviewList', params: { customer_id: data.sendAddress }}">
                <img
                  :src="
                    sender.image || require('@/assets/images/user_default.svg')
                  "
                  alt="..."
                  class="img-thumbnail is-rounded"
                />
              </router-link>
            </div>
            <div style="display: block" class="ml-10">
              <router-link :to="{name: 'CustomerReviewList', params: { customer_id: data.sendAddress }}" class="c-text-blue">
                <span>{{ sender.name }}</span>
              </router-link>
              <span> さん</span>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent is-6">
        <article class="tile is-child">
          <div style="display: flex">
            <star-rating
              :rating="parseInt(data.star)"
              :star-size="14"
              :show-rating="false"
              :read-only="true"
              :increment="0.1"
            ></star-rating>
          </div>
        </article>
      </div>
      <div class="tile is-parent is-3">
        <article class="tile is-child">
          <div class="date_detail">{{ createdAt }}</div>
        </article>
      </div>
    </div>
    <div class="tile is-ancestor comment">
      <div class="tile is-parent is-3">
        <article class="tile is-child"></article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child">
          <div v-if="hideSeeMore" class="comment-detail pre-line-all">
            {{ data.comment }}
          </div>
          <div v-else>
            <div>
              <span v-if="!dot" class="desc pre-line-all">{{
                data.comment
              }}</span>
              <dot
                v-if="dot"
                :msg="data.comment"
                :line="5"
                class="comment-detail pre-line-all"
                @isDot="isDot"
              />
              <span
                v-if="moreText && dot"
                style="color: #12a9db"
                class="show-more cursor_pointer"
                @click="dot = !dot"
                >もっと見る</span
              >
              <p
                v-if="!dot"
                style="color: #12a9db"
                class="show-more cursor_pointer"
                @click="dot = !dot"
              >
                少なく表示
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="./item-reviews.scss">
</style>

<script>
import { getUserProfileByAddress } from '../../../../services/profile.service';
import dataTransform from '../../../../utils/mixins/dataTransform';
import dot from 'vue-text-dot';
import StarRating from 'vue-star-rating';

export default {
  name: 'ItemShopReview',
  components: {
    dot: dot,
    StarRating
  },
  mixins: [dataTransform],
  props: {
    hideSeeMore: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    showLinkDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moreText: false,
      dot: true,
      sender: {}
    };
  },
  computed: {
    createdAt: function() {
      return this.formatEnStringDate(this.data.updatedAt * 1000);
    }
  },
  watch: {
    data: function(data) {
      if (data.sender !== {}) {
        this.getCustomerReview();
      }
    }
  },
  async created() {
    await this.getCustomerReview();
  },
  methods: {
    isDot() {
      this.moreText = true;
    },
    async getCustomerReview() {
      const { status, result } = await getUserProfileByAddress(this.data.sendAddress);

      if (status) {
        this.sender = result.data;
      }
    }
  }
};
</script>
